import * as ChapterType from "utils/ChapterType";
import { createSelector } from "reselect";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";

const getStory = (state) => state.story;

export const makeGetSlideshowSlides = () =>
  createSelector(getChapterEntity, getStory, (chapterEntity, story) => {
    if (
      !story ||
      !story.entities ||
      !chapterEntity ||
      chapterEntity.type !== ChapterType.SLIDESHOW
    ) {
      return [];
    }

    const entities = story.entities;
    if (!entities) {
      return [];
    }

    return chapterEntity.slides.map((slideId) => entities.slide[slideId]);
  });

export default makeGetSlideshowSlides();
